"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// rake referrer_options:create_constants_file generates this array
// run through ChatGPT with this prompt: convert this to js, convert underscore to camelCase

var ReferrerOptions = [{
  id: 'fedee26c-a4c0-4e6d-b5ff-feaf8eee0f39',
  languageId: 'DE',
  text: 'Other',
  slug: 'other-de'
}, {
  id: '06dd0a35-fcf4-4832-a920-1e104e734030',
  languageId: 'DE',
  text: 'Friend\'s Recommendation',
  slug: 'word-of-mouth-de'
}, {
  id: '121c5fd9-3265-4b98-b9f0-566d55bdba91',
  languageId: 'DE',
  text: 'Easy German',
  slug: 'easy-german'
}, {
  id: 'a361db27-5399-4b13-bb57-eab155b64ca3',
  languageId: 'DE',
  text: 'Instagram',
  slug: 'instagram'
}, {
  id: '6c680867-6217-4845-bbfa-0595ffa8b69a',
  languageId: 'DE',
  text: 'TikTok',
  slug: 'tik-tok'
}, {
  id: 'd981f27f-973a-4349-9c55-1daf1d125da6',
  languageId: 'DE',
  text: 'Google',
  slug: 'google'
}, {
  id: '7d1b69e0-e5e4-4978-aa14-0093220958a9',
  languageId: 'DE',
  text: 'Play Store',
  slug: 'play-store'
}, {
  id: 'cebaa92e-ac01-4d95-8cd8-2ab3a2c0ceef',
  languageId: 'DE',
  text: 'App Store',
  slug: 'app-store'
}, {
  id: '567b4d98-37bf-4f83-bd0d-de7e4793f791',
  languageId: 'ES',
  text: 'Easy Spanish',
  slug: 'easy-spanish'
}, {
  id: '238f710f-1ec2-48d5-a482-5a3ac2b56a31',
  languageId: 'ES',
  text: 'Friend\'s Recommendation',
  slug: 'word-of-mouth-es'
}, {
  id: 'ee4f2441-732f-4fad-b463-dee4f4f80641',
  languageId: 'ES',
  text: 'Search',
  slug: 'search-es'
}, {
  id: '31d2454c-9b2d-47a7-b399-9d85872c0239',
  languageId: 'ES',
  text: 'Seedlang Social Media',
  slug: 'seedlang-social-media-es'
}, {
  id: 'e1029aee-b69f-4d79-9f81-16c6181025e4',
  languageId: 'FR',
  text: 'Easy French',
  slug: 'easy-french'
}, {
  id: '567be476-bbc3-48f6-8a47-2243961e8b11',
  languageId: 'FR',
  text: 'Friend\'s Recommendation',
  slug: 'word-of-mouth-fr'
}, {
  id: 'e485538b-0362-4f56-a35f-8c890c96cd8b',
  languageId: 'FR',
  text: 'Search',
  slug: 'search-fr'
}, {
  id: '124ec94c-e4dd-4711-b7f9-8fd1d46b2905',
  languageId: 'FR',
  text: 'Seedlang Social Media',
  slug: 'seedlang-social-media-fr'
}];
var _default = exports["default"] = ReferrerOptions;